import styled from 'styled-components';

export const Container = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  flex: 1;
  padding: ${({ theme }) => theme.spacing.md};

  strong {
    cursor: pointer;
    font-weight: ${({ theme }) => theme.weights.bold};
  }
`;
